import regex from 'constant/regex';
import { useRouter } from 'next/router';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { PassengerMainFormType } from '../detail-passenger/types';

export class ShippingStorageSaver {
  static set(id: string, values: PassengerMainFormType) {
    localStorage.setItem(`shipping-form-${id}`, JSON.stringify(values));
    return values;
  }

  static get(id: string) {
    const value = localStorage.getItem(`shipping-form-${id}`);
    if (typeof value === 'string') {
      return JSON.parse(value) as PassengerMainFormType;
    }
    return value;
  }

  static removeAll() {
    Object.keys(localStorage)
      .filter((name) => name.includes('shipping-form-'))
      .map((key) => localStorage.removeItem(key));
  }
}

export default function ShippingFormStorageSaver() {
  const { query, isReady } = useRouter();
  const id = query.id as string | undefined;
  const firstTime = React.useRef(false);
  const { getValues, reset } = useFormContext<PassengerMainFormType>();
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!isReady) return;
    if (!id) return;
    if (regex.uuid.test(id) === false) return;

    if (firstTime.current === false) {
      const values = ShippingStorageSaver.get(id);
      if (values) {
        reset(values);
      }
      firstTime.current = true;
    }

    const interval = setInterval(() => {
      const values = getValues();
      ShippingStorageSaver.set(id, values);
    }, 3000);
    return () => clearInterval(interval);
  }, [getValues, id, isReady, reset]);

  return null;
}
